var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container right-wrap"},[_c('div',{staticClass:"right-section"},[_c('div',{staticClass:"right-headline"},[_c('p',[_vm._v("焦點新聞")]),_c('p',[_vm._v("查看全部")])]),_c('div',{staticClass:"right-content"})])])
}]

export { render, staticRenderFns }